


















































import { isEqual } from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'

import { RawChipItem } from "../../../../components/TypedChips/typedChips.types";
import DefaultValueWrapper from '../../../DefaultValueWrapper.vue'
import SettingWrapper from "../../../SettingWrapper.vue";
import TypedChips from "../../../TypedChips/TypedChips.vue";
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput, DefaultValueResetMixin } from '../../mixins'
import { TypedChipsWithSelectData } from './types'

@Component({
  components: {
    SettingWrapper,
    TypedChips,
    DefaultValueWrapper,
    FieldWrapper,
  },
})
export default class TypedChipsInput extends Mixins(BaseInput, DefaultValueResetMixin) {
  onChange(value: Array<RawChipItem>) {
    this.value = value
  }

  get chipsInputSettings(): TypedChipsWithSelectData {
    return this.settings as TypedChipsWithSelectData
  }

  mounted() {
    if (this.settings.settingWrapper !== undefined) {
      this.disabledSettingValueActive = isEqual(this.disabledOrActiveValue, this.value) || ((this.$slots['value-stub'] ?? false) && isEqual(this.disabledOrActiveValue, this.value))
    }
  }
}
